import { combineReducers } from 'redux';

import magazineArticles from './magazineArticles/reducer';

export default combineReducers({
  magazineArticles
});



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/paging/reducer.js
 **/